
/* eslint-disable max-len */
export default () => (
  <svg id="Laag_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
    <path
      d="M39.03,15.92l-4.67-.31c-.41-.03-.8-.16-1.14-.38l-3.47-2.29c-.4-.26-.82-.48-1.26-.64l-2.09-.78c-.99-.37-2.06-.49-3.11-.34l-5.59.79c-1.42.2-2.72.87-3.71,1.91l-3.15,3.31c-.81.85-.82,2.27.09,3.01.37.3.81.45,1.26.45.53,0,1.05-.21,1.44-.62l3.25-3.41c.37-.39.85-.64,1.38-.71l2.63-.37-2.98,6.61c-1.02,2.26-2.37,4.35-4,6.21h0c-.6.68-1.45,1.07-2.35,1.09l-6.45.14c-.98.02-1.88.71-2.02,1.68-.18,1.24.77,2.3,1.96,2.3h.04l6.55-.14c2.02-.04,3.92-.93,5.25-2.44l1.77-2.01s0,0,.01-.01l.42-.48c.33-.38.91-.41,1.28-.08l4.78,4.22c.71.63,1.27,1.4,1.64,2.27l2.93,6.9c.32.76,1.06,1.21,1.83,1.21.29,0,.59-.07.88-.21.97-.47,1.32-1.68.9-2.67l-2.63-6.2c-.85-2.01-1.76-3.28-2.92-4.29l-2.78-2.45c-.47-.42-.6-1.1-.32-1.66l4.26-8.36,2.11,1.38c.92.6,1.97.96,3.06,1.03l4.76.32c1.24.08,2.34-1.03,2.08-2.37-.17-.9-.99-1.54-1.9-1.6Z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.25"
    />
    <circle
      cx="28.54"
      cy="4.96"
      r="3.96"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.25"
    />
    <line
      x1="3.9"
      y1="43"
      x2="26.3"
      y2="43"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.25"
    />
    <line
      x1="36.6"
      y1="43"
      x2="42.01"
      y2="43"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.25"
    />
  </svg>
);
